import { render } from "./popup-change-rate.vue?vue&type=template&id=f312b4f2&ts=true"
import script from "./popup-change-rate.vue?vue&type=script&lang=ts"
export * from "./popup-change-rate.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__